import type { ApiClient } from "@cfg/api-contract";
import type { Brand } from "@cfg/brand-sdk";
import { createContext, useContext } from "react";
import type { Analytics } from "./analytics.ts";
import type { Auth } from "./auth.ts";
import type { Copy } from "./brand.ts";
import type { RegistryClient } from "./registry.ts";

export interface AppServices {
  /** The brand with its config localized for `locale` (tagline, fitTags, meta). */
  brand: Brand;
  /** Copy lookup for `locale`. */
  copy: Copy;
  /** Active locale (BCP 47), also for Intl date/number formatting. */
  locale: string;
  /** Switch language: re-renders in place and remembers the choice. */
  setLocale: (locale: string) => void;
  registry: RegistryClient;
  api: ApiClient | null;
  auth: Auth;
  analytics: Analytics;
}

export const AppCtx = createContext<AppServices | null>(null);

export function useApp(): AppServices {
  const v = useContext(AppCtx);
  if (!v) throw new Error("AppCtx missing");
  return v;
}
